export default __webpack_public_path__ + "static/media/bulletOrange.8b434b0b.svg";